"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NODE_TYPE_ORDER_BY = exports.ORDER_BY_OPERATOR_ORDER_BY = exports.ORDER_BY_DIRECTION_DESC = exports.ORDER_BY_DIRECTION_ASC = void 0;
exports.ORDER_BY_DIRECTION_ASC = 'ASC';
exports.ORDER_BY_DIRECTION_DESC = 'DESC';
exports.ORDER_BY_OPERATOR_ORDER_BY = 'ORDER BY';
exports.NODE_TYPE_ORDER_BY = 'order_by';
//# sourceMappingURL=order-by.js.map